import { getDataAttr, listen } from "@olmokit/dom";

const ATTR = "track-collection-link";

export default function trackCollectionLinks() {
  listen("click", `[data-${ATTR}]`, handleClickCollectionLink);

  /**
   * This function uses the event callback datalayer variable to handle
   * navigation after the ecommerce data has been sent to Google Analytics.
   *
   * @see https://www.simoahava.com/gtm-tips/use-eventtimeout-eventcallback/
   * @param {Event} event
   * @param {HTMLAnchorElement} $link
   */
  function handleClickCollectionLink(event, $link) {
    if (window["google_tag_manager"]) {
      event.preventDefault();
      const data = getCollectionClickData($link);

      dataLayer.push({
        ...data,
        eventCallback: function () {
          location.href = $link.href;
        },
        eventTimeout: 2000,
      });
    }
  }
}

/**
 * Actually send tracking data
 *
 * @param {HTMLAnchorElement} element
 * @data {{
 *   list: string,
 *   name: string,
 *   variant: string,
 *   position: string,
 * }} element["dataset"][ATTR]
 */
export function getCollectionClickData(element) {
  let data = getDataAttr(element, ATTR);
  if (data) data = JSON.parse(data);
  const { list, ...restData } = data;

  return {
    event: "productClick",
    ecommerce: {
      click: {
        actionField: {
          list,
        },
        products: [restData],
      },
    },
  };
}
